module.exports = __webpack_public_path__ + "assets/img/18_1829.a12b08d4.jpg";